import { getRandomInt, makeId } from '~/mixins/global'

import type {
  SpotifyPlaylistDetails,
  SpotifyTrackMoodDetails,
} from '~/types/spotify-core-api'
import type { SpotimoodFetch } from '~/types/SpotimoodFetch'

export const provideGetSpotifyPlaylistDetails = function (
  spotimoodFetch: SpotimoodFetch,
) {
  /**
   * Will return the data scrapped by @vyko's service.
   *
   * @param {string} spotifyPlaylistId - The playlist id should'nt include any `/` from the URL it was parsed from.
   * @returns {Promise<SpotifyPlaylistDetails>} Some infos about the playlist.
   */
  return function (
    spotifyPlaylistId: string,
  ): Promise<SpotifyPlaylistDetails | undefined> {
    return spotimoodFetch.$get(`/stats/${spotifyPlaylistId}/`)
  }
}

const _genTrackMoodDetails: () => SpotifyTrackMoodDetails = () => ({
  danceability: Math.random(),
  energy: Math.random(),
  key: getRandomInt(1, 12),
  loudness: getRandomInt(-60, 0),
  mode: getRandomInt(0, 1),
  speechiness: Math.random(),
  acousticness: Math.random(),
  instrumentalness: Math.random(),
  liveness: Math.random(),
  valence: Math.random(),
  tempo: getRandomInt(60, 180),
  duration_ms: getRandomInt(120000, 480000),
  time_signature: getRandomInt(3, 7),
})

export const _genRandomPlaylistDetail: () => SpotifyPlaylistDetails = () => ({
  trustability: Math.random(),
  mood: _genTrackMoodDetails(),
  name: makeId(),
  image: null,
  followers: getRandomInt(10, 100000),
})
